import { createAsyncThunk, createSlice, AsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { RootState } from '../store';
import { add } from 'date-fns';
import MerchantService from '../../API/eventMerchant';

interface Merchant {
	id: string;
	firstname: string;
	description: string;
}

interface AsyncThunkConfig {
	state: RootState;
	rejectValue: string;
}

//@ts-ignore
export const asyncRetrieveMerchant: AsyncThunk<Merchant[], void, AsyncThunkConfig> =
	createAsyncThunk('merchant/retrieve', async (_, thunkApi) => {
		try {
			const res = await MerchantService.retrieveAllMerchant();
			// console.log(res.data.user);
			return res.data.user;
		} catch (error: any) {
			const errorMessage =
				(error.response && error.response.data && error.response.data.message) ||
				error.message ||
				error.toString();
			// toast.error(errorMessage);
			return thunkApi.rejectWithValue(errorMessage);
		}
	});

const merchantSlice = createSlice({
	name: 'merchant',
	initialState: {
		data: [] as Merchant[],
		isLoading: false,
	},
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addCase(asyncRetrieveMerchant.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(asyncRetrieveMerchant.fulfilled, (state, action) => {
				state.isLoading = false;
				state.data = action.payload;
			})
			.addCase(asyncRetrieveMerchant.rejected, (state) => {
				state.isLoading = false;
			});
	},
});

export const allMerchant = (state: RootState) => state.merchants;
export default merchantSlice.reducer;
